import React from 'react';

function Send(props) {
    const fill = props.fill || 'currentColor';
    const secondaryfill = props.secondaryfill || fill;
    const strokewidth = props.strokewidth || 1;
    const width = props.width || '1em';
    const height = props.height || '1em';

    return (
        <svg height={height} width={width} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth={strokewidth}>
                <path d="M21.5,12L3.5,3.5L5.5,12L3.5,20.5L21.5,12z" />
                <line x1="5.5" y1="12" x2="13.5" y2="12" />
            </g>
        </svg>
    );
};

export default Send; 